var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashbackV2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58333 8.0875C2.49786 8.0875 2.42857 8.1549 2.42857 8.23804V10.1251H3.43045C3.68687 10.1251 3.89474 10.3273 3.89474 10.5767C3.89474 10.8261 3.68687 11.0283 3.43045 11.0283H2.42857V13.0554C2.42857 13.1386 2.49786 13.206 2.58333 13.206H13.4167C13.5021 13.206 13.5714 13.1386 13.5714 13.0554V11.0283H12.2763C12.0199 11.0283 11.812 10.8261 11.812 10.5767C11.812 10.3273 12.0199 10.1251 12.2763 10.1251H13.5714V8.23804C13.5714 8.1549 13.5021 8.0875 13.4167 8.0875H2.58333ZM1.5 8.23804C1.5 7.65604 1.98503 7.18424 2.58333 7.18424H13.4167C14.015 7.18424 14.5 7.65604 14.5 8.23804V13.0554C14.5 13.6374 14.015 14.1092 13.4167 14.1092H2.58333C1.98502 14.1092 1.5 13.6374 1.5 13.0554V8.23804Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12381 11.6004C8.70502 11.6004 9.17619 11.1421 9.17619 10.5767C9.17619 10.0113 8.70502 9.55302 8.12381 9.55302C7.5426 9.55302 7.07143 10.0113 7.07143 10.5767C7.07143 11.1421 7.5426 11.6004 8.12381 11.6004ZM8.12381 12.3832C9.14948 12.3832 9.98095 11.5744 9.98095 10.5767C9.98095 9.579 9.14948 8.77019 8.12381 8.77019C7.09814 8.77019 6.26667 9.579 6.26667 10.5767C6.26667 11.5744 7.09814 12.3832 8.12381 12.3832Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9012 2.11464C4.05834 2.2675 4.05834 2.51533 3.9012 2.66818L3.04049 3.50543L14.0976 3.57121C14.3198 3.57121 14.5 3.74646 14.5 3.96263C14.5 4.1788 14.3198 4.35404 14.0976 4.35404L3.04049 4.28826L3.9012 5.1255C4.05834 5.27836 4.05834 5.52619 3.9012 5.67905C3.74406 5.8319 3.48928 5.8319 3.33215 5.67905L1.5 3.89684L3.33215 2.11464C3.48928 1.96179 3.74406 1.96179 3.9012 2.11464Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashbackV2);
export default __webpack_public_path__ + "static/media/cashback-v2.c56a6b77b927393de730d838a610bb36.svg";
export { ForwardRef as ReactComponent };